<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-wrapper">

  <!-- ─── En-tête ─────────────────────────────────── -->
  <div class="page-header">
    <div class="page-title">
      <div class="title-icon"><i class="pi pi-briefcase"></i></div>
      <div>
        <h2>Transactions</h2>
        <span class="count-badge">{{ totalCount }} transaction(s)</span>
      </div>
    </div>
    <div class="header-actions">
      <button pButton type="button"
        [icon]="showFilters ? 'pi pi-filter-slash' : 'pi pi-filter'"
        [label]="showFilters ? 'Masquer filtres' : 'Filtres'"
        class="p-button-outlined p-button-sm"
        (click)="showFilters = !showFilters">
      </button>
      <button pButton type="button" icon="pi pi-refresh" label="Rafraîchir"
        class="p-button-outlined p-button-sm" (click)="load()">
      </button>
      <button pButton type="button" icon="pi pi-plus" label="Nouvelle transaction"
        class="p-button-sm btn-create" (click)="openCreate()">
      </button>

      <!-- Inputs fichiers cachés -->
      <input #csvImportInput type="file" accept=".csv,.txt" hidden
        (change)="onCsvFileSelected($event)" />
      <input #mobileDeleteExcelInput type="file" accept=".xlsx,.xlsm" hidden
        (change)="onMobileDeleteExcelSelected($event)" />
    </div>
  </div>

  <!-- ─── Panneau filtres ──────────────────────────── -->
  <div class="filter-panel" *ngIf="showFilters">
    <div class="search-wrap">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Client, réf, banque, assureur…"
          [(ngModel)]="search" (ngModelChange)="onSearchChange()" style="width:220px" />
      </span>
    </div>

    <div class="filter-sep"></div>

    <div class="filter-group">
      <label>Phase</label>
      <p-dropdown [options]="phaseFilterOptions" [(ngModel)]="selectedPhase"
        optionLabel="label" optionValue="value"
        (onChange)="reload()"
        [style]="{ minWidth:'220px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Origine</label>
      <p-dropdown [options]="origineFilterOptions" [(ngModel)]="selectedOrigine"
        optionLabel="label" optionValue="value"
        [showClear]="true" placeholder="Toutes"
        (onChange)="reload()" (onClear)="reload()"
        [style]="{ minWidth:'175px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group" *ngIf="isAdmin">
      <label>Conseiller</label>
      <p-dropdown [options]="usersFilter" [(ngModel)]="selectedUserId"
        optionLabel="label" optionValue="value"
        [filter]="true" filterBy="label"
        [showClear]="true" placeholder="Tous"
        (onChange)="reload()" (onClear)="reload()"
        [style]="{ minWidth:'170px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Période de création</label>
      <p-calendar [(ngModel)]="dateRange" selectionMode="range"
        [readonlyInput]="true" dateFormat="dd/mm/yy"
        placeholder="Du … au …" appendTo="body"
        (onSelect)="onDateRangeChange()" (onClearClick)="onDateRangeChange()"
        [showButtonBar]="true" [style]="{ minWidth:'200px' }">
      </p-calendar>
    </div>

    <button *ngIf="hasActiveFilters" pButton type="button"
      icon="pi pi-times" label="Effacer les filtres"
      class="p-button-sm p-button-text p-button-secondary"
      (click)="clearFilters()">
    </button>
  </div>

  <!-- ─── Chip filtre contact ──────────────────────── -->
  <div *ngIf="contactId">
    <span class="contact-chip">
      <i class="pi pi-user"></i>
      Filtré sur le contact #{{ contactId }}
      <button pButton type="button" icon="pi pi-times"
        class="p-button-text p-button-sm p-button-rounded"
        style="width:1.4rem;height:1.4rem"
        (click)="clearContactFilter()">
      </button>
    </span>
  </div>

  <!-- ─── Barre d'actions unifiée ─────────────────── -->
  <div class="action-bar">
    <span class="bulk-count" [class.has-selection]="selected.length">
      <i class="pi pi-check-square"></i>
      {{ selected.length }} sélectionnée(s)
    </span>
    <button *ngIf="selected.length" pButton type="button" icon="pi pi-times" label="Désélectionner"
      class="p-button-sm p-button-text" (click)="selected = []; selectedAction = null">
    </button>
    <span class="bulk-sep"></span>

    <p-dropdown [options]="actionOptions" [(ngModel)]="selectedAction"
      optionLabel="label" optionValue="value"
      placeholder="Choisir une action…" [showClear]="true"
      appendTo="body" [style]="{ minWidth:'240px' }">
      <ng-template let-opt pTemplate="item">
        <span><i [class]="opt.icon" style="margin-right:.5rem"></i>{{ opt.label }}</span>
      </ng-template>
    </p-dropdown>

    <!-- Sous-champ : phase -->
    <p-dropdown *ngIf="selectedAction === 'phase'"
      [options]="phaseEditOptions" [(ngModel)]="bulkPhase"
      placeholder="Nouvelle phase…"
      appendTo="body" [style]="{ minWidth:'210px' }">
    </p-dropdown>

    <!-- Sous-champ : conseiller -->
    <p-dropdown *ngIf="selectedAction === 'assign'"
      [options]="usersFilter" [(ngModel)]="selectedAssignUserId"
      optionLabel="label" optionValue="value"
      [filter]="true" filterBy="label"
      placeholder="Conseiller cible…"
      appendTo="body" [style]="{ minWidth:'200px' }">
    </p-dropdown>

    <button pButton type="button" label="Exécuter" icon="pi pi-play"
      class="p-button-sm"
      [disabled]="!canExecuteAction()"
      [loading]="isBulkBusy()"
      (click)="executeAction()">
    </button>

    <span *ngIf="selectedAction && actionNeedsSelection(selectedAction) && !selected.length"
      class="action-hint">
      <i class="pi pi-info-circle"></i> Sélectionnez au moins une ligne
    </span>
  </div>

  <!-- ─── Tableau ──────────────────────────────────── -->
  <!-- Pas de *ngIf sur le conteneur : en pagination serveur, retirer la table du
       DOM pendant le chargement la ferait se réinitialiser (et redéclencher
       onLazyLoad). L'attente est rendue par [loading] de p-table. -->
  <div class="table-card">
    <p-table
      [value]="transactions"
      [(selection)]="selected"
      dataKey="id"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [loading]="loading"
      [paginator]="true"
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="totalCount"
      [rowsPerPageOptions]="[15, 25, 50, 100]"
      currentPageReportTemplate="{first} à {last} sur {totalRecords}"
      [showCurrentPageReport]="true"
      styleClass="p-datatable-sm p-datatable-gridlines"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width:3rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th style="width:10%">Produit</th>
          <th style="min-width:210px">Client</th>
          <th style="min-width:215px">Phase</th>
          <th style="min-width:185px">Prêt</th>
          <th style="min-width:165px">Devis</th>
          <th style="min-width:170px">Statut du lead</th>
          <th style="min-width:110px">Résultat d'appel</th>
          <th style="min-width:100px">Créée le</th>
          <th style="width:155px; text-align:center">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-t>
        <tr>
          <!-- Case à cocher -->
          <td><p-tableCheckbox [value]="t"></p-tableCheckbox></td>

          <!-- Produit (branche de l'affaire) — affichage seul -->
          <td>
            <span class="produit-pill">{{ t.famille_produit || 'EMPRUNTEUR' }}</span>
          </td>

          <!-- Client + Référence -->
          <td>
            <div class="client-cell" *ngIf="t.contact; else noClient">
              <div class="client-avatar" [style.background]="contactAvatarColor(t)">{{ contactInitials(t) }}</div>
              <div class="client-info">
                <div class="client-name">{{ contactName(t) }}</div>
                <div class="ref-cell-inline">{{ t.reference || t.project_id }}</div>
                <div class="client-meta">
                  <span *ngIf="t.contact.mobile"><i class="pi pi-mobile"></i>{{ t.contact.mobile }}</span>
                  <span *ngIf="!t.contact.mobile && t.contact.ville">{{ t.contact.ville }}</span>
                </div>
              </div>
            </div>
            <ng-template #noClient>
              <div class="client-cell">
                <div class="client-avatar" style="background:#e2e8f0;color:#94a3b8">?</div>
                <div class="client-info">
                  <div class="ref-cell-inline">{{ t.reference || t.project_id }}</div>
                </div>
              </div>
            </ng-template>
          </td>

          <!-- Phase inline dropdown + tag -->
          <td>
            <div class="phase-cell">
              <p-tag [value]="t.phase_transaction || '—'"
                [severity]="phaseSeverity(t.phase_transaction)"
                [style]="{ fontSize:'.72rem', padding:'.2rem .6rem', maxWidth:'100%', whiteSpace:'normal', textAlign:'left' }">
              </p-tag>
              <p-dropdown
                [options]="phaseEditOptions"
                [(ngModel)]="t.phase_transaction"
                (onChange)="updateField(t, 'phase_transaction', $event.value)"
                [showClear]="true" placeholder="Changer…"
                appendTo="body"
                [style]="{ width:'100%', fontSize:'.8rem' }">
              </p-dropdown>
            </div>
          </td>

          <!-- Prêt (banque + objet + montant + taux/durée) -->
          <td>
            <div class="pret-cell">
              <div class="pret-banque-line" *ngIf="t.banque">
                <i class="pi pi-building"></i>{{ banqueLabel(t.banque) }}
              </div>
              <div class="pret-amount" *ngIf="t.montant_credit != null">
                {{ t.montant_credit | number:'1.0-0' }} €
              </div>
              <div class="pret-objet" *ngIf="t.objet_du_pret">{{ t.objet_du_pret }}</div>
              <div class="pret-meta">
                <span *ngIf="t.taux != null">{{ t.taux }} %</span>
                <span *ngIf="t.duree != null">{{ t.duree }} mois</span>
              </div>
              <span *ngIf="!t.banque && t.montant_credit == null && !t.objet_du_pret" style="color:#cbd5e1">—</span>
            </div>
          </td>

          <!-- Devis -->
          <td>
            <div class="devis-mini">
              <span class="devis-mini-badge" [class.sent]="hasDevis(t)">
                <i class="pi" [class.pi-check-circle]="hasDevis(t)" [class.pi-clock]="!hasDevis(t)"></i>
                {{ hasDevis(t) ? (t.nbre_devis_envoyes || '✓') : '—' }}
              </span>
              <div class="devis-best" *ngIf="t.assureur_moins_cher || t.tarif_mensuel_moins_cher != null">
                <i class="pi pi-star-fill"></i>
                <span class="db-name">{{ t.assureur_moins_cher || '—' }}</span>
                <span class="db-price" *ngIf="t.tarif_mensuel_moins_cher != null">
                  {{ t.tarif_mensuel_moins_cher | number:'1.0-0' }} €/m
                </span>
              </div>
            </div>
          </td>

          <!-- Statut du lead inline (source : contact, partagé historique/agenda) -->
          <td>
            <p-dropdown
              [options]="leadStatusOptionsFor(t)"
              [ngModel]="t.contact?.statut_du_lead || null"
              (onChange)="updateLeadStatus(t, $event.value)"
              [disabled]="savingLeadStatusId === t.id || !t.contact"
              placeholder="—"
              appendTo="body" [style]="{ width:'100%', fontSize:'.8rem' }">
            </p-dropdown>
          </td>

          <!-- Résultat d'appel (OK / NRP, null = jamais appelé) — éditable -->
          <td>
            <div class="phase-cell">
              <p-tag [value]="resultatAppelLabel(t.resultat_appel)"
                [severity]="resultatAppelSeverity(t.resultat_appel)" [rounded]="true">
              </p-tag>
              <p-dropdown
                [options]="resultatAppelOptions"
                [ngModel]="t.resultat_appel || null"
                (onChange)="updateField(t, 'resultat_appel', $event.value)"
                [showClear]="!!t.resultat_appel" placeholder="Changer…"
                appendTo="body"
                [style]="{ minWidth:'100px', fontSize:'.8rem' }">
              </p-dropdown>
            </div>
          </td>

          <!-- Date création -->
          <td>
            <div *ngIf="t.date_creation_transaction" style="font-size:.8rem;color:#64748b;line-height:1.4">
              <div>{{ t.date_creation_transaction | date:'dd/MM/yyyy' }}</div>
              <div style="font-size:.72rem;color:#94a3b8">{{ t.date_creation_transaction | date:'HH:mm' }}</div>
            </div>
            <span *ngIf="!t.date_creation_transaction" style="color:#cbd5e1">—</span>
          </td>

          <!-- Actions -->
          <td>
            <div class="row-actions">
              <button pButton type="button" icon="pi pi-eye"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Détails" tooltipPosition="top"
                (click)="openDetails(t)">
              </button>
              <button pButton type="button" icon="pi pi-folder-open"
                class="p-button-rounded p-button-text p-button-sm btn-form"
                pTooltip="Ouvrir le formulaire" tooltipPosition="top"
                [disabled]="openingForm"
                (click)="openInForm(t)">
              </button>
              <button pButton type="button" icon="pi pi-copy"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Dupliquer" tooltipPosition="top"
                [disabled]="duplicatingId === t.id || !t.project_id"
                (click)="duplicateOne(t)">
              </button>
              <button pButton type="button" icon="pi pi-comment"
                class="p-button-rounded p-button-text p-button-sm btn-comment"
                [class.has-comment]="!!t.commentaire"
                [pTooltip]="t.commentaire || 'Aucun commentaire'" tooltipPosition="top"
                (click)="openComment(t)">
              </button>
              <button pButton type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                pTooltip="Supprimer" tooltipPosition="top"
                (click)="deleteOne(t)">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" class="empty">
            <i class="pi pi-inbox"></i>
            Aucune transaction trouvée.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>

<!-- ─── Dialog Détails : 2 panneaux (contact + transaction) ─── -->
<p-dialog
  header="Détails de la transaction"
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width:'1150px', maxWidth:'97vw' }"
  [dismissableMask]="true"
>
  <div *ngIf="selectedTransaction as t" class="split-view">

  <!-- ░░░ Colonne gauche : fiche contact ░░░ -->
  <div class="split-col contact-col details">
    <div class="col-head">
      <div class="contact-avatar lg" [style.background]="'#6366f1'">
        {{ selectedContact ? initials(selectedContact) : '?' }}
      </div>
      <div>
        <div class="col-head-title">{{ selectedContact ? fullName(selectedContact) : 'Contact' }}</div>
        <div class="col-head-sub">{{ selectedContact?.reference || ('#' + t.contact_id) }}</div>
      </div>
    </div>

    <div *ngIf="loadingContact" class="mini-spinner">
      <p-progressSpinner [style]="{width:'34px',height:'34px'}"></p-progressSpinner>
    </div>

    <ng-container *ngIf="!loadingContact && selectedContact as c">
      <!-- Actions rapides -->
      <div class="quick-actions">
        <button pButton type="button" icon="pi pi-phone" label="Appeler"
          class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a"
          [disabled]="!c.mobile && !c.fixe" (click)="callContact(c)"></button>
        <button pButton type="button" label="SMS"
          class="p-button-sm p-button-outlined sms-text-btn" style="color:#0891b2;border-color:#0891b2"
          [disabled]="!c.mobile" (click)="smsContact(c)"></button>
      </div>

      <h4>Assuré 1</h4>
      <div class="grid">
        <div><label>Civilité</label><span>{{ c.civilite || '—' }}</span></div>
        <div><label>Nom</label><span>{{ c.nom || '—' }}</span></div>
        <div><label>Prénom</label><span>{{ c.prenom || '—' }}</span></div>
        <div><label>Date naissance</label><span>{{ c.date_naissance ? (c.date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
        <div><label>Mobile</label><span>{{ c.mobile || '—' }}</span></div>
        <div><label>Fixe</label><span>{{ c.fixe || '—' }}</span></div>
        <div><label>Email</label><span>{{ c.email || '—' }}</span></div>
        <div><label>Ville</label><span>{{ c.ville || '—' }}</span></div>
        <div><label>Code postal</label><span>{{ c.code_postal || '—' }}</span></div>
        <div><label>Profession</label><span>{{ c.profession_exacte || '—' }}</span></div>
        <div><label>Statut lead</label><span>{{ c.statut_du_lead || '—' }}</span></div>
        <div><label>Type contact</label><span>{{ c.type_contact || '—' }}</span></div>
        <div><label>Cycle de vie</label><span>{{ c.cycle_de_vie || '—' }}</span></div>
        <div><label>Fumeur</label><span>{{ c.fumeur ? 'Oui' : 'Non' }}</span></div>
      </div>

      <ng-container *ngIf="c.est_assure2">
        <h4>Assuré 2</h4>
        <div class="grid">
          <div><label>Civilité</label><span>{{ c.assure2_civilite || '—' }}</span></div>
          <div><label>Nom</label><span>{{ c.assure2_nom || '—' }}</span></div>
          <div><label>Prénom</label><span>{{ c.assure2_prenom || '—' }}</span></div>
          <div><label>Date naissance</label><span>{{ c.assure2_date_naissance ? (c.assure2_date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
          <div><label>Mobile</label><span>{{ c.assure2_mobile || '—' }}</span></div>
          <div><label>Email</label><span>{{ c.assure2_email || '—' }}</span></div>
          <div><label>Profession</label><span>{{ c.assure2_profession_exacte || '—' }}</span></div>
          <div><label>Fumeur</label><span>{{ c.assure2_fumeur ? 'Oui' : 'Non' }}</span></div>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="!loadingContact && !selectedContact" class="mini-empty">
      <i class="pi pi-user-minus"></i>
      Fiche contact indisponible.
    </div>
  </div>

  <!-- ░░░ Colonne droite : détails transaction ░░░ -->
  <div class="split-col trans-col details">

    <!-- Actions rapides -->
    <div class="quick-actions">
      <button pButton type="button" icon="pi pi-folder-open" label="Ouvrir le formulaire"
        class="p-button-sm p-button-outlined"
        style="color:#7c3aed;border-color:#7c3aed"
        [disabled]="openingForm"
        (click)="openInForm(t)">
      </button>
    </div>

    <!-- ── Carte Devis & Contrat (dynamique) ── -->
    <div class="devis-card">
      <!-- En-tête statut -->
      <div class="devis-card-head">
        <span class="devis-card-status" [class.devis-card-status--sent]="t.devis_envoye || t.nbre_devis_envoyes">
          <i class="pi" [class.pi-check-circle]="t.devis_envoye || t.nbre_devis_envoyes"
                        [class.pi-clock]="!t.devis_envoye && !t.nbre_devis_envoyes"></i>
          {{ (t.devis_envoye || t.nbre_devis_envoyes) ? 'Devis envoyé' : 'Pas encore envoyé' }}
        </span>
        <span *ngIf="t.nbre_devis_envoyes" class="devis-card-count">{{ t.nbre_devis_envoyes }} envoyé(s)</span>
        <span *ngIf="t.date_envoi_devis" class="devis-card-date">
          <i class="pi pi-calendar"></i>{{ t.date_envoi_devis | date:'dd/MM/yyyy' }}
        </span>
        <span class="devis-card-spacer"></span>
        <span *ngIf="t.statut_contrat" class="devis-card-contrat"
          [class.contrat-ok]="t.statut_contrat === 'En cours'">
          <i class="pi pi-file-check"></i> {{ t.statut_contrat }}
        </span>
      </div>

      <!-- Une carte par devis envoyé (JSON historique) -->
      <ng-container *ngIf="parseDevisHistory(t) as history">
        <div *ngIf="history.length" class="devis-quotes-list">
          <div *ngFor="let d of history; let i = index" class="devis-quote-card">
            <div class="dqc-top">
              <span class="dqc-num">#{{ i + 1 }}</span>
              <span class="dqc-assureur">{{ d.assureur }}</span>
              <span class="dqc-date">{{ d.date | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="dqc-body">
              <div *ngIf="d.montant_mensuel">
                <label>Mensuel</label>
                <span class="dqc-price">{{ d.montant_mensuel | number:'1.0-2' }} €</span>
              </div>
              <div *ngIf="d.montant_total">
                <label>Total</label>
                <span>{{ d.montant_total | number:'1.0-2' }} €</span>
              </div>
              <div *ngIf="d.label">
                <label>Produit</label><span>{{ d.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Fallback texte si données pas encore en JSON -->
        <div *ngIf="!history.length && t.nom_assureurs" class="devis-card-body">
          <div><label>Assureurs</label><span>{{ t.nom_assureurs }}</span></div>
          <div *ngIf="t.cout_mensuel_assurance != null">
            <label>Mensuel</label>
            <span class="devis-price">{{ t.cout_mensuel_assurance | number:'1.0-2' }} €/mois</span>
          </div>
        </div>
      </ng-container>

      <!-- Contrat souscrit -->
      <div class="devis-card-body devis-card-body--contract"
        *ngIf="t.assureur || t.numero_contrat || t.motif_refus">
        <div *ngIf="t.assureur"><label>Assureur souscrit</label><span>{{ t.assureur }}</span></div>
        <div *ngIf="t.numero_contrat"><label>N° contrat</label><span>{{ t.numero_contrat }}</span></div>
        <div *ngIf="t.motif_refus"><label>Motif refus</label><span class="text-danger">{{ t.motif_refus }}</span></div>
      </div>

      <!-- Édition rapide -->
      <div class="devis-card-edit">
        <label class="devis-card-edit-label">Statut contrat</label>
        <p-dropdown [options]="statutContratOptions" [(ngModel)]="t.statut_contrat"
          (onChange)="updateField(t, 'statut_contrat', $event.value)"
          [showClear]="true" placeholder="—"
          appendTo="body" [style]="{ minWidth:'140px', fontSize:'.82rem' }">
        </p-dropdown>
        <label class="devis-card-edit-label" style="margin-left:.75rem">Devis envoyé</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="t.devis_envoye"
          (onChange)="updateField(t, 'devis_envoye', $event.value)"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ minWidth:'100px', fontSize:'.82rem' }">
        </p-dropdown>
      </div>
    </div>

    <h4>Suivi</h4>
    <div class="grid">
      <div><label>Référence</label><span>{{ t.reference || t.project_id }}</span></div>
      <div><label>Phase</label><span>{{ t.phase_transaction || '—' }}</span></div>
      <div><label>Date création</label><span>{{ t.date_creation_transaction ? (t.date_creation_transaction | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date contact</label><span>{{ t.date_contact ? (t.date_contact | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date d'effet</label><span>{{ t.date_effective ? (t.date_effective | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date envoi devis</label><span>{{ t.date_envoi_devis ? (t.date_envoi_devis | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date dern. demande info</label><span>{{ t.date_derniere_demande_information ? (t.date_derniere_demande_information | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Résultat appel</label><span>{{ t.resultat_appel || '—' }}</span></div>
      <div><label>Revenu</label><span>{{ t.revenu != null ? (t.revenu | number:'1.0-2') + ' €' : '—' }}</span></div>
      <div><label>Commentaire</label><span>{{ t.commentaire || '—' }}</span></div>
    </div>

    <h4>Contrat souscrit</h4>
    <div class="grid">
      <div><label>N° contrat</label><span>{{ t.numero_contrat || '—' }}</span></div>
      <div><label>Nb contrats</label><span>{{ t.nb_contrat ?? '—' }}</span></div>
      <div><label>Produit</label><span>{{ t.produit || '—' }}</span></div>
      <div><label>Nom produit</label><span>{{ t.nom_produit || '—' }}</span></div>
      <div><label>Précédent assureur</label><span>{{ t.precedent_assureur || '—' }}</span></div>
    </div>

    <h4>Prêt</h4>
    <div class="grid">
      <div><label>Objet du prêt</label><span>{{ t.objet_du_pret || '—' }}</span></div>
      <div><label>Type prêt</label><span>{{ t.type_pret || '—' }}</span></div>
      <div><label>Type reprise</label><span>{{ t.type_reprise || '—' }}</span></div>
      <div><label>Montant crédit</label><span>{{ t.montant_credit != null ? (t.montant_credit | number:'1.0-0') + ' €' : '—' }}</span></div>
      <div><label>Taux</label><span>{{ t.taux != null ? t.taux + ' %' : '—' }}</span></div>
      <div><label>Durée</label><span>{{ t.duree != null ? t.duree + ' mois' : '—' }}</span></div>
      <div><label>Date fin prêt</label><span>{{ t.date_fin_pret ? (t.date_fin_pret | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Banque</label><span>{{ t.banque || '—' }}</span></div>
      <div><label>Quotité A1</label><span>{{ t.quotite != null ? t.quotite + ' %' : '—' }}</span></div>
      <div><label>Quotité A2</label><span>{{ t.assure2_quotite != null ? t.assure2_quotite + ' %' : '—' }}</span></div>
      <div><label>Total encours</label><span>{{ t.total_encours != null ? (t.total_encours | number:'1.0-0') + ' €' : '—' }}</span></div>
    </div>

    <h4>Risque Assuré 1</h4>
    <div class="grid">
      <div><label>Déplacement pro</label><span>{{ t.deplacement_professionnel || '—' }}</span></div>
      <div><label>Travaille en hauteur</label><span>{{ t.travaille_en_hauteur || '—' }}</span></div>
      <div><label>Port de charge</label><span>{{ t.port_charge ? 'Oui' : 'Non' }}</span></div>
      <div><label>Nb enfants assurés</label><span>{{ t.nb_enfant_assure ?? '—' }}</span></div>
    </div>

    <h4>Risque Assuré 2</h4>
    <div class="grid">
      <div><label>Déplacement pro</label><span>{{ t.assure2_deplacement_professionnel || '—' }}</span></div>
      <div><label>Travaille en hauteur</label><span>{{ t.assure2_travaille_en_hauteur || '—' }}</span></div>
      <div><label>Port de charge</label><span>{{ t.assure2_port_charge ? 'Oui' : 'Non' }}</span></div>
    </div>

    <h4>Résultats comparateur</h4>
    <div class="best-quote"
      *ngIf="t.assureur_moins_cher || t.tarif_mensuel_moins_cher != null; else noBest">
      <div class="best-quote-icon"><i class="pi pi-star-fill"></i></div>
      <div class="best-quote-main">
        <div class="best-quote-label">Meilleure offre</div>
        <div class="best-quote-assureur">{{ t.assureur_moins_cher || '—' }}</div>
      </div>
      <div class="best-quote-prices">
        <div class="best-quote-monthly" *ngIf="t.tarif_mensuel_moins_cher != null">
          {{ t.tarif_mensuel_moins_cher | number:'1.0-2' }} €<span>/mois</span>
        </div>
        <div class="best-quote-total" *ngIf="t.cotisation_totale_moins_chere != null">
          {{ t.cotisation_totale_moins_chere | number:'1.0-0' }} € au total
        </div>
      </div>
    </div>
    <ng-template #noBest>
      <div class="grid">
        <div><label>Résultat comparateur</label><span style="color:#cbd5e1">Aucun résultat enregistré</span></div>
      </div>
    </ng-template>
  </div>

  </div>
</p-dialog>

<!-- ─── Dialog Nouvelle transaction ──────────────────── -->
<p-dialog
  header="Nouvelle transaction"
  [(visible)]="createVisible"
  [modal]="true"
  [style]="{ width:'900px', maxWidth:'97vw' }"
  [contentStyle]="{ maxHeight:'78vh', overflowY:'auto' }"
  [dismissableMask]="true"
>
  <div class="create-form">

    <!-- ══ Contact ══ -->
    <div class="create-section">Contact lié <span class="req">*</span></div>
    <div class="create-grid">
      <div class="create-field cf-full">
        <label>Contact</label>
        <p-dropdown [options]="contactOptions" [(ngModel)]="newTransaction.contact_id"
          [filter]="true" filterBy="label" [loading]="loadingContactOpts"
          placeholder="Rechercher un contact…"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
    </div>

    <!-- ══ Pipeline / Suivi ══ -->
    <div class="create-section">Pipeline & Suivi</div>
    <div class="create-grid">
      <div class="create-field cf-wide">
        <label>Phase</label>
        <p-dropdown [options]="phaseEditOptions" [(ngModel)]="newTransaction.phase_transaction"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Date contact</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_contact" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date d'effet</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_effective" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date envoi devis</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_envoi_devis" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date dernière demande info</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_derniere_demande_information" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Résultat appel</label>
        <p-dropdown [options]="resultatAppelOptions" [(ngModel)]="newTransaction.resultat_appel"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field cf-wide">
        <label>Commentaire</label>
        <input pInputText [(ngModel)]="newTransaction.commentaire" placeholder="Notes…" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Revenu (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.revenu" placeholder="0" style="width:100%" />
      </div>
    </div>

    <!-- ══ Prêt principal ══ -->
    <div class="create-section">Prêt principal</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Objet du prêt</label>
        <p-dropdown [options]="objetPretOptions" [(ngModel)]="newTransaction.objet_du_pret"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Type de prêt</label>
        <p-dropdown [options]="typesPretOptions" [(ngModel)]="newTransaction.type_pret"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Type reprise</label>
        <p-dropdown [options]="typeRepriseOptions" [(ngModel)]="newTransaction.type_reprise"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Montant crédit (€)</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.montant_credit" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Taux (%)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.taux" placeholder="0.00" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Durée (mois)</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.duree" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date fin prêt</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_fin_pret" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Total encours (€)</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.total_encours" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Quotité Assuré 1 (%)</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.quotite" placeholder="100" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Quotité Assuré 2 (%)</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.assure2_quotite" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Banque</label>
        <p-dropdown [options]="banquesOptions" [(ngModel)]="newTransaction.banque"
          optionLabel="label" optionValue="value"
          [filter]="true" filterBy="label"
          [showClear]="true" placeholder="Rechercher une banque…"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
    </div>

    <!-- ══ Prêts additionnels ══ -->
    <div class="create-section">Prêts additionnels (2 à 5)</div>
    <ng-container *ngFor="let p of [pret2, pret3, pret4, pret5]; let i = index">
      <div class="create-pret-label">Prêt {{ i + 2 }}</div>
      <div class="create-grid">
        <div class="create-field">
          <label>Type</label>
          <p-dropdown [options]="typesPretOptions" [(ngModel)]="p.type_pret"
            [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
          </p-dropdown>
        </div>
        <div class="create-field">
          <label>Montant (€)</label>
          <input pInputText type="number" [(ngModel)]="p.montant_credit" placeholder="0" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Taux (%)</label>
          <input pInputText type="number" step="0.01" [(ngModel)]="p.taux" placeholder="0.00" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Durée (mois)</label>
          <input pInputText type="number" [(ngModel)]="p.duree" placeholder="0" style="width:100%" />
        </div>
      </div>
    </ng-container>

    <!-- ══ Risque ══ -->
    <div class="create-section">Risque Assuré 1</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Déplacement professionnel</label>
        <p-dropdown [options]="deplacementOptions" [(ngModel)]="newTransaction.deplacement_professionnel"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Travaille en hauteur</label>
        <p-dropdown [options]="travailEnHauteurOptions" [(ngModel)]="newTransaction.travaille_en_hauteur"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Port de charge</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newTransaction.port_charge"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Nb enfants assurés</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nb_enfant_assure" placeholder="0" style="width:100%" />
      </div>
    </div>

    <div class="create-section">Risque Assuré 2</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Déplacement professionnel</label>
        <p-dropdown [options]="deplacementOptions" [(ngModel)]="newTransaction.assure2_deplacement_professionnel"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Travaille en hauteur</label>
        <p-dropdown [options]="travailEnHauteurOptions" [(ngModel)]="newTransaction.assure2_travaille_en_hauteur"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Port de charge</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newTransaction.assure2_port_charge"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
    </div>

    <!-- ══ Devis / Contrat ══ -->
    <div class="create-section">Devis & Contrat</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Nb devis envoyés</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nbre_devis_envoyes" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Devis envoyé</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newTransaction.devis_envoye"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field cf-wide">
        <label>Noms assureurs proposés</label>
        <input pInputText [(ngModel)]="newTransaction.nom_assureurs" placeholder="Assureur 1, Assureur 2…" style="width:100%" />
      </div>
      <div class="create-field">
        <label>N° devis</label>
        <input pInputText [(ngModel)]="newTransaction.numero_devis" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>N° contrat</label>
        <input pInputText [(ngModel)]="newTransaction.numero_contrat" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Statut contrat</label>
        <p-dropdown [options]="statutContratOptions" [(ngModel)]="newTransaction.statut_contrat"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Nb contrats</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nb_contrat" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Assureur souscrit</label>
        <input pInputText [(ngModel)]="newTransaction.assureur" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Produit</label>
        <input pInputText [(ngModel)]="newTransaction.produit" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Nom produit</label>
        <input pInputText [(ngModel)]="newTransaction.nom_produit" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Coût mensuel assurance (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.cout_mensuel_assurance" placeholder="0.00" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Coût total assurance (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.cout_total_assurance" placeholder="0.00" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Précédent assureur</label>
        <input pInputText [(ngModel)]="newTransaction.precedent_assureur" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Motif refus</label>
        <input pInputText [(ngModel)]="newTransaction.motif_refus" placeholder="—" style="width:100%" />
      </div>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" icon="pi pi-times"
      class="p-button-text p-button-secondary" (click)="createVisible = false">
    </button>
    <button pButton type="button" label="Créer la transaction" icon="pi pi-check"
      class="p-button-sm btn-create" [disabled]="saving" (click)="saveTransaction()">
    </button>
  </ng-template>
</p-dialog>

<!-- ── SMS : relecture avant envoi (via Ringover) ── -->
<p-dialog
  header="Vérifier et envoyer le SMS"
  [(visible)]="smsDialogVisible"
  [modal]="true"
  [style]="{ width:'560px', maxWidth:'96vw' }"
  [dismissableMask]="true">
  <div *ngIf="smsDialogContact" style="display:flex;flex-direction:column;gap:10px">
    <div style="display:flex;align-items:center;gap:8px;color:#555">
      <i class="pi pi-mobile"></i>
      <div>
        <div style="font-weight:600">{{ fullName(smsDialogContact) }}</div>
        <div style="font-size:12px;color:#888">{{ smsDialogPhone }}</div>
      </div>
    </div>
    <div style="display:flex;align-items:center;justify-content:space-between;font-size:12px;color:#555">
      <span><i class="pi pi-pencil"></i> Message SMS</span>
      <span [style.color]="smsDialogContent.length > 800 ? '#d97706' : '#888'">
        {{ smsDialogContent.length }} caractères
      </span>
    </div>
    <textarea [(ngModel)]="smsDialogContent" rows="12"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      placeholder="Rédigez votre message…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      Vous pouvez modifier le message avant de l'envoyer. L'envoi est effectué via Ringover.
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="smsDialogVisible = false" [disabled]="smsDialogSending">
    </button>
    <button pButton type="button" label="Envoyer le SMS" icon="pi pi-send"
      class="p-button-sm" style="background:#0891b2;border-color:#0891b2"
      [disabled]="smsDialogSending || !smsDialogContent.trim()"
      [loading]="smsDialogSending"
      (click)="sendSmsFromDialog()">
    </button>
  </ng-template>
</p-dialog>

<!-- ── Commentaire de la transaction ── -->
<p-dialog
  header="Commentaire"
  [(visible)]="commentDialogVisible"
  [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '520px', maxWidth: '95vw' }">
  <div style="display:flex;flex-direction:column;gap:8px">
    <div style="font-size:12px;color:#888">{{ commentDialogTitle }}</div>
    <textarea [(ngModel)]="commentDialogText" rows="8"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      placeholder="Ce qu'on a fait avec ce contact…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      Commentaire partagé avec l'historique des projets et l'agenda.
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Fermer" icon="pi pi-times"
      class="p-button-text p-button-secondary" (click)="commentDialogVisible = false"
      [disabled]="savingComment">
    </button>
    <button pButton type="button" label="Enregistrer" icon="pi pi-check"
      class="p-button-sm" [loading]="savingComment"
      [disabled]="savingComment || !commentDialogProjectId" (click)="saveComment()">
    </button>
  </ng-template>
</p-dialog>
